import { render } from "./ProductScoreBad.vue?vue&type=template&id=cf6182da"
import script from "./ProductScoreBad.vue?vue&type=script&lang=js"
export * from "./ProductScoreBad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__